<main class="dialog-body">
  <div class="dialog-header">
    <div class="d-flex align-items-center gap-3">
      <div class="back-button" *ngIf="stepNext === 2" (click)="goStepone()">
        <img src="assets/images/Buttons/arrow-left.svg" class="back-icon" />
      </div>
      <div class="dialog-header-text">
        {{
          isEdit ? "Edit event registration form" : "Event registration form"
        }}
      </div>
    </div>
    <div class="d-flex align-items-center gap-3">
      <div *ngIf="currentUserRole === 'superadmin'" class="d-flex align-items-center gap-2">
        <label class="backdated-toggle" [class.disabled]="isEdit">
          <input
            type="checkbox"
            [(ngModel)]="isBackdatedToggle"
            (change)="onBackdatedToggleChange()"
            [disabled]="isEdit"
          />
          <span class="backdated-slider"></span>
        </label>
        <span style="font-size: 0.8rem; color: #fff; white-space: nowrap;">
          Backdated event
          <span *ngIf="isEdit" style="opacity: 0.5; font-size: 0.7rem;"> (locked)</span>
        </span>
      </div>
      <div class="cross-icon" (click)="onCancel(false)">
        <img src="assets/images/cross-icon.svg" class="cross-icon-img" />
      </div>
    </div>
  </div>

  <mat-dialog-content class="dialog-content">
    <!-- STEP 1: Basic Event Information -->
    <form [formGroup]="form" *ngIf="stepNext === 1">
      <div class="p-4 d-grid gap-14">
        <div class="form-group d-grid gap-3">
          <app-input
            context="Normal"
            label="Event type"
            placeholder="Select event type"
            type="select"
            [control]="form.get('eventName')"
            [options]="eventTypeOptions"
            [required]="true"
            [customErrorMessages]="{ required: 'Please select a event type.' }"
            (selectionChange)="onEventNameChange($event)"
          >
          </app-input>

          <div *ngIf="selectedEventTypeImage" class="event-type-preview">
            <div class="event-type-image">
              <img [src]="selectedEventTypeImage" alt="" />
            </div>
            <div
              *ngIf="selectedEventTypeDescription"
              class="event-type-description"
            >
              <p>{{ selectedEventTypeDescription }}</p>
            </div>
          </div>
        </div>

        <!-- <div class="w-100">
                    <div class="Normal-label mb-2">Event description
                    </div>
                    <div class="note-container">
                        <div>
                            <textarea class="note-input" [(ngModel)]="noteText" formControlName="eventDescription"
                                (input)="autoResize($event)" placeholder="Enter your description"></textarea>
                        </div>
                    </div>
                </div> -->

        <!-- <div class="w-100">
                    <div class="Normal-label mb-2">Event image
                    </div>

                    <div class="file-upload-section">
                        <div class="upload-area"
                            [ngClass]="fileControl.touched && fileControl.invalid ? 'upload-area-error' : ''"
                            (click)="fileInput.click()">
                            <input type="file" #fileInput (change)="onFileSelected($event)" accept="image/*" hidden
                                multiple>
                            <img class="upload-icon" src="assets/images/image-add.svg" />
                            <p class="upload-text">Drag & drop file or <span>browse</span></p>
                            <p class="format-info">Supported formats: PNG, JPEG</p>
                        </div>

                        <div class="uploaded-images-container" *ngIf="uploadedImages.length > 0">
                            <div class="uploaded-images-header">Uploaded Images ({{ uploadedImages.length }})</div>
                            <div class="uploaded-images-grid">
                                <div class="uploaded-image-item" *ngFor="let image of uploadedImages; let i = index">
                                    <img [src]="image.url" class="image-preview" />
                                    <div class="image-actions">
                                        <span class="image-name">{{ image.name }}</span>
                                        <button class="remove-image-btn" (click)="removeImage(i)">×</button>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="error-message"
                            *ngIf="fileControl.touched && (fileControl.invalid || fileControl.hasError('invalidType'))">
                            Please upload a valid image file (PNG, JPEG).
                        </div>
                    </div>
                </div> -->

        <div class="d-flex gap-3 wrap-768">
          <div class="form-group" [ngClass]="{'disabled': isCsqUser}">
            <app-input
              context="Normal"
              label="Event manager"
              placeholder="Select event manager"
              type="select"
              [control]="form.get('eventManager')"
              [options]="eventMangerOptions"
              [required]="true"
              [disabled]="isCsqUser"
              [customErrorMessages]="{
                required: 'Please select a event manager.',
              }"
            >
            </app-input>
          </div>

          <div class="form-group">
            <app-input
              context="Normal"
              label="Audience type"
              placeholder="Select audience type"
              type="select"
              [control]="form.get('audienceType')"
              [options]="audienceTypeOptions"
              [required]="true"
              [customErrorMessages]="{
                required: 'Please select a audience type.',
              }"
            >
            </app-input>
          </div>
        </div>

        <div class="grid-container">
          <div class="w-100">
            <!-- <div class="d-flex justify-content-between">
                            <div class="Normal-label">Start & end date <span class="req-star">*</span></div>
                            <div class="Normal-label">No.of days</div>
                        </div> -->
            <div class="event-date-container wrap-600">
              <div style="display: grid; gap: 0.5rem; width: 100%">
                <div class="date_label">
                  Start & end date <span class="req-star">*</span>
                </div>
                <div
                  style="
                    display: grid;
                    grid-template-columns: 6fr 6fr;
                    gap: 0.5rem;
                  "
                >
                  <div class="form-group">
                    <app-input
                      context="Normal"
                      label=""
                      [required]="true"
                      placeholder="From"
                      type="date"
                      [control]="form.get('fromDate')"
                      (dateChange)="validateDates()"
                      [min]="minDateValue"
                      [disableWeekends]="true"
                      [customErrorMessages]="{
                        required: 'Please enter a start date',
                        weekend:
                          'Weekends are not available for event scheduling.',
                      }"
                    >
                    </app-input>
                  </div>

                  <div class="form-group">
                    <app-input
                      context="Normal"
                      label=""
                      placeholder="To"
                      type="date"
                      [control]="form.get('toDate')"
                      (dateChange)="validateDates()"
                      [min]="getMinEndDate()"
                      [isEndDateCalendar]="true"
                      [disableWeekends]="true"
                      [customErrorMessages]="{
                        required: 'Please enter an end date',
                        dateRange: 'End date must be after start date',
                        weekend:
                          'Weekends are not available for event scheduling.',
                      }"
                    >
                    </app-input>
                  </div>
                </div>
              </div>

              <div
                class="form-group"
                [style.margin-bottom]="hasDateFieldError() ? '26px' : '0px'"
              >
                <app-input
                  context="Normal"
                  placeholder="0"
                  type="text"
                  label="No. of days"
                  [control]="form.get('noOfDays')"
                  [customErrorMessages]="{ required: '' }"
                >
                </app-input>
              </div>
            </div>
          </div>

          <div class="d-flex gap-3 w-100 flex-wrap">
            <div class="w-100">
              <div class="form-group flex-wrap">
                <app-input
                  context="Normal"
                  label="Start & end time"
                  [required]="true"
                  placeholder="Select time"
                  type="time"
                  [control]="form.get('eventTime')"
                  [customErrorMessages]="{
                    required: 'Please enter start and end time..',
                    invalidFormat: 'Invalid time format. Use HH:mm format',
                    timeRange: 'End time must be after start time',
                  }"
                >
                </app-input>
              </div>
            </div>
          </div>
        </div>

        <div class="form-group">
          <app-input
            label="Event location"
            placeholder="Enter your full street address"
            type="textarea"
            context="Normal"
            [control]="form.get('address')"
            [required]="true"
            [textareaMaxLength]="199"
            [customErrorMessages]="{
              required: 'Please enter a event location.',
              whitespace: 'Please enter a event location.',
            }"
          >
          </app-input>
        </div>

        <div class="d-grid">
          <div class="Normal-label">
            Focus area <span class="req-star">*</span>
          </div>
          <div class="focuse-area-grid">
            <div class="checkbox-container" *ngFor="let item of focusAreas">
              <input
                type="checkbox"
                class="checkbox-input"
                [id]="item.id"
                [value]="item.id"
                [checked]="isFocusAreaSelected(item.id)"
                (change)="onCheckboxChange($event, item)"
              />
              <label [for]="item.id" class="checkbox-label">{{
                item.name
              }}</label>
            </div>
          </div>
          <div class="error-message-container">
            <div class="error-message" *ngIf="focusAreaError">
              Please select a focus area
            </div>
          </div>
        </div>
        <div class="d-flex gap-14 wrap-768">
          <div class="form-group">
            <app-input
              context="Normal"
              label="Region"
              placeholder="Select region"
              type="select"
              [control]="form.get('eventRegion')"
              [options]="eventRegionOptions"
              [required]="true"
              [customErrorMessages]="{
                required: 'Please select a region.',
                noMouSchools:
                  'The selected region does not have any Partnership School/s.',
                noNonMouSchools:
                  'The selected region does not have any Non-Partnership School/s.',
                noSchools:
                  'The selected region does not have any schools available.',
              }"
            >
            </app-input>
          </div>
        </div>
        <div [formGroup]="stepTwoForm" class="d-grid gap-24">
          <div class="toggle-container">
            <label class="toggle-text">
              <span>Will any Partnership School/s be attending?</span>
              <input
                id="isMouSchool"
                formControlName="isMouSchool"
                type="checkbox"
                class="toggle-input"
                (change)="onMouSchoolToggle()"
              />
              <span class="toggle-switch"></span>
            </label>
          </div>

          <div *ngIf="stepTwoForm.get('isMouSchool')!.value" class="d-grid gap-3">
            <div class="add-school-section">
              <div class="search-school-header">
                Search school<span class="req-star">*</span>
              </div>
              <div class="custom-select-container">
                <div class="custom-select-wrapper">
                  <div class="search-input-container">
                    <input
                      type="text"
                      class="search-input"
                      placeholder="Search schools by name"
                      [(ngModel)]="searchText"
                      [ngModelOptions]="{ standalone: true }"
                      (input)="filterSchools()"
                      (focus)="openDropdown()"
                    />
                  </div>

                  <div class="custom-select-dropdown" *ngIf="isDropdownOpen">
                    <div class="dropdown-options">
                      <div
                        *ngFor="let option of filteredSchools; let i = index"
                        class="dropdown-option"
                        (click)="selectSchool(option, 'mou')"
                      >
                        {{ getSchoolLabel(option) }}
                      </div>
                      <div *ngIf="filteredSchools.length === 0" class="no-options">
                        No schools found
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="selected-schools-section">
                <div class="selected-schools-header">
                  Selected Schools
                  <span class="schools-count">{{ mouSchools.length }} schools added</span>
                </div>

                <div class="selected-schools-list">
                  <div
                    *ngFor="let schoolItem of mouSchools; let i = index"
                    class="selected-school-card"
                  >
                    <div class="school-info">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="school-name">
                          {{ getSchoolLabel(schoolItem.school) }}
                        </div>
                        <div class="d-flex">
                          <img
                            *ngIf="schoolItem.teachers.length > 0"
                            src="assets/images/Buttons/arrow.svg"
                            class="arrow-icon"
                            (click)="toggleMouTeachers(i)"
                            [style.transform]="
                              schoolItem.showTeachers
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)'
                            "
                          />
                          <img
                            src="assets/images/Buttons/delete-button.svg"
                            class="trash-icon"
                            (click)="deleteMouSchool(i)"
                          />
                        </div>
                      </div>
                      <div class="teacher-count" *ngIf="schoolItem.teachers.length > 0">
                        {{ schoolItem.teachers.length }} teachers assigned
                      </div>
                      <div class="teachers-info" *ngIf="schoolItem.teachers.length === 0">
                        No teachers assigned yet
                      </div>
                      <div
                        class="teachers-list"
                        *ngIf="
                          schoolItem.teachers.length > 0 &&
                          schoolItem.showTeachers
                        "
                      >
                        <div class="assign-teacher-text">Assigned teachers</div>
                        <div
                          *ngFor="
                            let teacher of schoolItem.teachers;
                            let teacherIndex = index
                          "
                          class="teacher-tag"
                        >
                          {{ getTeacherLabel(teacher) }}
                          <img
                            src="assets/images/x-icon.svg"
                            class="trash-icon"
                            (click)="removeMouTeacher(i, teacherIndex)"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      class="assign-teacher-btn"
                      type="button"
                      (click)="openAssignTeacher(schoolItem.school, i, 'mou')"
                    >
                      + Assign teachers
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="toggle-container">
            <label class="toggle-text">
              <span>Will any Non-Partnership School/s be attending?</span>
              <input
                id="isNonMouSchool"
                formControlName="isNonMouSchool"
                type="checkbox"
                class="toggle-input"
                (change)="onNonMouSchoolToggle()"
              />
              <span class="toggle-switch"></span>
            </label>
          </div>

          <div
            *ngIf="stepTwoForm.get('isNonMouSchool')!.value"
            class="d-grid gap-3"
          >
            <div class="add-school-section">
              <div class="search-school-header">
                Search school<span class="req-star">*</span>
              </div>

              <div class="custom-select-container">
                <div class="custom-select-wrapper">
                  <div class="search-input-container">
                    <input
                      type="text"
                      class="search-input"
                      placeholder="Search schools by name"
                      [(ngModel)]="nonMouSearchText"
                      [ngModelOptions]="{ standalone: true }"
                      (input)="filterNonMouSchools()"
                      (focus)="openNonMouDropdown()"
                    />
                  </div>

                  <div
                    class="custom-select-dropdown"
                    *ngIf="isNonMouDropdownOpen"
                  >
                    <div class="dropdown-options">
                      <div
                        *ngFor="
                          let option of filteredNonMouSchools;
                          let i = index
                        "
                        class="dropdown-option"
                        (click)="selectSchool(option, 'nonMou')"
                      >
                        {{ getSchoolLabel(option) }}
                      </div>
                      <div *ngIf="filteredNonMouSchools.length === 0" class="no-options">
                        No schools found
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div
                class="selected-schools-section"
                *ngIf="nonMouSchools.length > 0"
              >
                <div class="selected-schools-header">
                  Selected Schools
                  <span class="schools-count">{{ nonMouSchools.length }} schools added</span>
                </div>

                <div class="selected-schools-list">
                  <div
                    *ngFor="let schoolItem of nonMouSchools; let i = index"
                    class="selected-school-card"
                  >
                    <div class="school-info">
                      <div class="d-flex justify-content-between align-items-center">
                        <div class="school-name">
                          {{ getSchoolLabel(schoolItem.school) }}
                        </div>
                        <div class="d-flex">
                          <img
                            *ngIf="schoolItem.teachers.length > 0"
                            src="assets/images/Buttons/arrow.svg"
                            class="arrow-icon"
                            (click)="toggleNonMouTeachers(i)"
                            [style.transform]="
                              schoolItem.showTeachers
                                ? 'rotate(180deg)'
                                : 'rotate(0deg)'
                            "
                          />
                          <img
                            src="assets/images/Buttons/delete-button.svg"
                            class="trash-icon"
                            (click)="deleteNonMouSchool(i)"
                          />
                        </div>
                      </div>
                      <div class="teacher-count" *ngIf="schoolItem.teachers.length > 0">
                        {{ schoolItem.teachers.length }} teachers assigned
                      </div>
                      <div class="teachers-info" *ngIf="schoolItem.teachers.length === 0">
                        No teachers assigned yet
                      </div>
                      <div
                        class="teachers-list"
                        *ngIf="
                          schoolItem.teachers.length > 0 &&
                          schoolItem.showTeachers
                        "
                      >
                        <div class="assign-teacher-text">Assigned teachers</div>
                        <div
                          *ngFor="
                            let teacher of schoolItem.teachers;
                            let teacherIndex = index
                          "
                          class="teacher-tag"
                        >
                          {{ getTeacherLabel(teacher) }}
                          <img
                            src="assets/images/x-icon.svg"
                            class="trash-icon"
                            (click)="removeNonMouTeacher(i, teacherIndex)"
                          />
                        </div>
                      </div>
                    </div>
                    <button
                      class="assign-teacher-btn"
                      type="button"
                      (click)="openAssignTeacher(schoolItem.school, i, 'nonMou')"
                    >
                      + Assign teachers
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="d-grid gap-24">
          <div class="d-grid gap-14">
            <div>
              <div class="Normal-label">
                Is catering required?<span class="req-star">*</span>
              </div>
              <div class="sub-text">
                Please check the program guide for your event type on the
                construction pathways internal website to see if catering is
                provided.
              </div>
            </div>

            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="Select your answer"
                type="select"
                [control]="form.get('cateringRequired')"
                [options]="yesNoOptions"
                [required]="true"
                [customErrorMessages]="{
                  required: 'Please select if catering is required.',
                }"
              >
              </app-input>
            </div>
          </div>

          <div class="d-grid gap-14">
            <div>
              <div class="Normal-label">
                Is a bus required?<span class="req-star">*</span>
              </div>
              <div class="sub-text">
                Please check the program guide for your event type on the
                construction pathways internal website to see if transportation
                is provided. Before selecting yes, confirm if participants
                already have access to a private bus through their sport club /
                school / organisation.
              </div>
            </div>

            <div class="form-group">
              <app-input
                context="Normal"
                label=""
                placeholder="Select your answer"
                type="select"
                [control]="form.get('busRequired')"
                [options]="yesNoOptions"
                [required]="true"
                [customErrorMessages]="{
                  required: 'Please select if a bus is required.',
                }"
              >
              </app-input>
            </div>
          </div>

          <div class="form-group">
            <app-input
              context="Normal"
              label="Do you require anything extra to bring this event to life (e.g. extra PPE, equipment, gazelo, VR)?"
              placeholder="Enter your answer"
              type="text"
              [control]="form.get('extraRequirements')"
            >
            </app-input>
          </div>
        </div>
      </div>
    </form>

    <form [formGroup]="stepTwoForm" *ngIf="stepNext === 2">
      <div class="p-4 d-grid gap-24">
        <!-- Other form fields -->
        <div class="form-group" *ngIf="showCareerSeekerField">
          <app-input
            context="Normal"
            label="If applicable, what career seeker organisations / sports clubs will be engaging with"
            placeholder="Enter your answer"
            type="text"
            [control]="stepTwoForm.get('careerSeekerOrganisations')"
          >
          </app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            label="Approximate number of participants and supervisors"
            placeholder="Example : 20 students, 2 supervisors"
            type="text"
            [required]="true"
            [control]="stepTwoForm.get('approximateParticipants')"
            [customErrorMessages]="{
              required:
                'Please enter a approximate number of participants and supervisors.',
              whitespace:
                'Please enter a approximate number of participants and supervisors.',
            }"
          >
          </app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            label="If applicable, does this event lead to an approved pre-trade CSQ funded opportunity?"
            placeholder="Select your answer"
            type="select"
            [control]="stepTwoForm.get('preTradeOpportunity')"
            [options]="yesNoOptions"
            [customErrorMessages]="{
              required: 'Please select a answer for this question.',
            }"
          >
          </app-input>
        </div>

        <div class="form-group">
          <app-input
            context="Normal"
            label="Will we be collaborating with any organisations to deliver this event?"
            placeholder="Select your answer"
            type="select"
            [control]="stepTwoForm.get('collaboratingOrganisations')"
            [options]="yesNoOptions"
            [required]="true"
            [customErrorMessages]="{
              required: 'Please select a answer for this question.',
            }"
            (selectionChange)="onCollaborationDetailsChange($event)"
          >
          </app-input>
        </div>

        <div class="form-group" *ngIf="showCollaborationDetails">
          <app-input
            context="Normal"
            label="Who are we collaborating with for this event?"
            placeholder="Select your answer"
            type="select"
            [control]="stepTwoForm.get('collaboratingWith')"
            [options]="collaboratingOptions"
            [required]="true"
            [customErrorMessages]="{ required: 'Please select an answer.' }"
            (selectionChange)="onCollaborationChange($event)"
          >
          </app-input>
        </div>
        <div
          class="form-group"
          *ngIf="showMccPartners && showCollaborationDetails"
        >
          <app-multi-select
            #mccMultiSelect
            [label]="'Industry Partners'"
            placeholder="Select your answer"
            [options]="mccPartnersOptions"
            [required]="showMccPartners"
            [errorMessage]="'Please select partners'"
            formControlName="mccPartners"
            (selectionChange)="onMccPartnersChange($event)"
          >
          </app-multi-select>
        </div>

        <div
          class="form-group"
          *ngIf="showNonMccPartners && showCollaborationDetails"
        >
          <app-input
            context="Normal"
            label="Non-Industry Partners"
            placeholder="Enter a partners"
            type="text"
            [control]="stepTwoForm.get('nonMccPartners')"
            [required]="showNonMccPartners"
            [customErrorMessages]="{
              required: 'Please enter a partners.',
              whitespace: 'Please enter a partners.',
            }"
          >
          </app-input>
        </div>
      </div>
    </form>

    <div *ngIf="stepNext === 3">
      <div
        class="d-flex justify-content-center align-items-center flex-column gap-0"
      >
        <img src="assets/animations/success-img.gif" class="success-img" />
        <div class="submit-text">Submitted</div>
        <div class="submit-subtext">All data uploaded successfully</div>
      </div>

      <div class="d-flex justify-content-center align-items-center">
        <div *ngIf="isSyncAsana" class="synced-green-card">
          <img src="assets/images/check-broken.svg" class="success-icon" />
          <div class="d-grid">
            <div class="primary-text">Synced with asana</div>
            <div class="secondary-text">
              {{ currentDateTime }} by {{ user.name }}
            </div>
          </div>
        </div>

        <div *ngIf="isSyncAsanaFailed" class="synced-red-card">
          <img
            src="assets/images/x-circle-contained.svg"
            class="success-icon"
          />
          <div class="d-grid">
            <div class="primary-text">Synced with asana</div>
            <div class="secondary-text">
              {{ currentDateTime }} by {{ user.name }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions class="action-buttons">
    <!-- <button
      class="dialog-button update-button"
      [disabled]="syncLoading"
      type="button"
      *ngIf="stepNext === 3 && !this.isSavedAsDraft"
      (click)="syncAsana()"
    >
      Sync with asana
    </button> -->
    <button
      class="dialog-button cancel-button"
      type="button"
      [disabled]="isProcessing || isDraftProcessing"
      (click)="onCancel(false)"
    >
      {{ stepNext === 3 ? "Close" : "Cancel" }}
    </button>

    <button
      class="dialog-button draf-button"
      type="button"
      [disabled]="isProcessing || isDraftProcessing"
      *ngIf="stepNext !== 3 && (initialData?.isDraft || !isEdit)"
      (click)="onSubmit('draft')"
    >
      <span *ngIf="!isDraftProcessing">Save as draft</span>
      <span *ngIf="isDraftProcessing" class="submit-loading">
        <span class="spinner"></span>
        Submitting...
      </span>
    </button>
    <button
      class="dialog-button update-button"
      type="button"
      (click)="onSubmit('')"
      [disabled]="isProcessing || isDraftProcessing"
      *ngIf="stepNext !== 3"
    >
      <span *ngIf="!isProcessing && stepNext === 1">{{
        isEdit ? "Next" : "Save & next"
      }}</span>
      <span *ngIf="!isProcessing && stepNext === 2">{{
        isEdit ? "Update & publish" : "Save & publish"
      }}</span>
      <span *ngIf="isProcessing" class="submit-loading">
        <span class="spinner"></span>
        Submitting...
      </span>
    </button>
  </mat-dialog-actions>
</main>
